import { queryKeys } from "@/lib/queryKeys";
import { useSdk } from "@cs_teamwaydev/mailvista-sdk_react";
import {
    useMutation,
    UseMutationResult,
    useQueryClient,
} from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import useErrorToast from "../utils/useErrorToast";
import { useToast } from "../utils/useToast";

const useDeleteUserSignature = (): {
    deleteUserSignature: UseMutationResult<void, Error, string>;
} => {
    const { userManager } = useSdk();
    const queryClient = useQueryClient();
    const showErrorToast = useErrorToast();
    const { toast } = useToast();
    const { t } = useTranslation();

    const deleteUserSignatureFn = async (id: string): Promise<void> => {
        try {
            await userManager.deleteUserSignature(id);

            queryClient.setQueryData(queryKeys.user.signature(), null);

            toast({
                description: t("settings.signature.form.deleteSuccess"),
                variant: "success",
            });
        } catch (error) {
            console.error(error);
            showErrorToast({
                titleTranslationKey: "errors.signature.delete",
            });
        }
    };

    const deleteUserSignature = useMutation({
        mutationFn: (id: string) => deleteUserSignatureFn(id),
    });

    return {
        deleteUserSignature,
    };
};

export default useDeleteUserSignature;
